// ==============================|| Software Version ||============================== //
export const SOFTWARE_VERSION = "2.23.7";

// ==============================|| SoMe URL's ||============================== //
export const conversionSubscriptionUrl = "conversion/subscription/user";
export const conversionSignupUrl = "conversion/signup/user";

// ==============================|| AI CHAT CONFIG ||============================== //
export const AI_CHAT_GROUPING_INTERVAL = 10 * 60 * 1000;
export const AI_AVAILABLE_COUNTRY_CODES = ["DK"];
export const AI_APP_CONTEXT_SCHEMA_VERSION = "1.0";

// ==============================|| Style CONFIG ||============================== //
export const drawerWidth = 260;

// ==============================|| GENERAL APP CONFIG ||============================== //
export const LOADING_TIMER = 1000; // in ms
export const DEFAULT_SNACKBAR_DISMISS_TIMEOUT = 5000; // in ms
export const LONG_SNACKBAR_DISMISS_TIMEOUT = 15000; // in ms
export const ERROR_REPORTING_EMAIL = "app@skovkortet.dk";
export const DISABLE_AUDIENCE = false;
export const PAGES: string[] = [
  "home-page",
  "map-page",
  "lists-page",
  "projects-page",
  "files-page",
  "estates-page",
  "team-and-contacts-page",
  "profile-page",
  "account-page",
];
export const DEFAULT_TRIAL_SUBSCRIPTION = "advanced";
export const TBD_SPECIES = "To be determined";
export const lang = ["da", "en", "sv", "no", "de", "es"] as const;
export type I18n = (typeof lang)[number];
export const emailLang = ["da", "en"] as const;
export type EMAIL_LANGUAGE = (typeof emailLang)[number];

// ==============================|| FILES CONFIG ||============================== //
export const DEFAULT_SUPPORTED_FILE_TYPES = [
  "JPG",
  "JPEG",
  "jpg",
  "jpeg",
  "png",
  "webp",
  "heic",
  "pdf",
  "csv",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
  "txt",
  "mp4",
  "mov",
  "MOV",
];
export const DEFAULT_SUPPORTED_FILE_SIZE = 50 * 1024 * 1024; // 50 MB
export const DEFAULT_BRANDING_SUPPORTED_FILE_TYPES = ["image/png", "image/jpeg", "image/svg+xml"];
export const DEFAULT_BRANDING_SUPPORTED_FILE_SIZE = 400 * 1024;
export const DEFAULT_FILE_CATEGORIES = [
  "map",
  "budget-tracking",
  "invoices",
  "account-statements",
  "settlements",
  "other",
] as const;
export type DEFAULT_FILE_CATEGORIES_TYPE = (typeof DEFAULT_FILE_CATEGORIES)[number];

// ==============================|| CATEGORIES CONFIG ||============================== //
export const DEFAULT_MAP_LAYERS = ["forest", "nature", "other"] as const;
export type DEFAULT_MAP_LAYERS_TYPE = (typeof DEFAULT_MAP_LAYERS)[number];
export const DEFAULT_CERTIFICATION_MAP_LAYERS = ["forest", "nature"] as const;
export type DEFAULT_CERTIFICATION_MAP_LAYERS_TYPE =
  (typeof DEFAULT_CERTIFICATION_MAP_LAYERS)[number];

export const SPECIAL_STYLE_CATEGORIES = [
  "intensive",
  "biodiversity",
  "untouched",
  "internal",
  "private",
] as const;
export type SPECIAL_STYLE_CATEGORIES_TYPE = (typeof SPECIAL_STYLE_CATEGORIES)[number];

export const CERTIFICATION_CATEGORIES = ["fsc", "pefc", "ukwas"] as const;
export type CERTIFICATION_CATEGORIES_TYPE = (typeof CERTIFICATION_CATEGORIES)[number];

export const DEFAULT_CATEGORIES = [
  ...DEFAULT_MAP_LAYERS,
  ...SPECIAL_STYLE_CATEGORIES,
  ...CERTIFICATION_CATEGORIES,
  "audience",
  "hunting",
] as const;
export type DEFAULT_CATEGORIES_TYPE = (typeof DEFAULT_CATEGORIES)[number];

export const DEFAULT_STAND_CATEGORIES = ["primary", "secondary", "overstorey"] as const;
export type DEFAULT_STAND_CATEGORIES_TYPE = (typeof DEFAULT_STAND_CATEGORIES)[number];

// ==============================|| ACTIVITIES CONFIG ||============================== //
export const NEW_PROJECT_YEAR_RANGE = 11;
export const DEFAULT_PROJECT_STATUS = ["active", "archived"] as const;
export type DEFAULT_PROJECT_STATUS_TYPE = (typeof DEFAULT_PROJECT_STATUS)[number];
export const DEFAULT_ACTIVITY_STATUS = [
  "not-decided",
  "not-started",
  "in-progress",
  "done",
] as const;
export type DEFAULT_ACTIVITY_STATUS_TYPE = (typeof DEFAULT_ACTIVITY_STATUS)[number];

// ==============================|| INVENTORY CONFIG ||============================== //
export const INVENTORY_WOOD_LOG_SPECIES = ["Oak", "Beech", "Ash", "Norway spruce", "Sitka spruce"];

// ==============================|| MAP LAYERS CONFIG ||============================== //
export const THEME_GROUPS_DK = [
  {
    id: "screening-dk",
    label: "Screening",
    countryCode: "DK",
    primaryLayers: [
      "protectedNatureDK",
      "protectedForestDK",
      "FrededeområderDK",
      "protectedAncientAreas",
      "protectedOakGroveDK",
      "ÅbeskytlinjDK",
      "coastelProtectionLineDK",
      "natura2000DK",
      "cadastralDK",
      "redListSpeciesDK",
      "appendixSpeciesDK",
      "valuableNatureForestDK",
      "naturmæssigtSærligVærdifuldSkovPaaPrivateArealerDK",
    ],
    secondaryLayers:[
      "HNV_HELELANDET2021DK"
    ],
  },
  {
    id: "screening-dk-forest",
    label: "Screening skov",
    countryCode: "DK",
    primaryLayers: [
      "protectedNatureDK",
      "protectedForestDK",
      "FrededeområderDK",
      "protectedAncientAreas",
      "protectedOakGroveDK",
      "ÅbeskytlinjDK",
      "coastelProtectionLineDK",
      "natura2000DK",
      "cadastralDK",
      "redListSpeciesDK",
      "appendixSpeciesDK",
      "valuableNatureForestDK",
      "naturmæssigtSærligVærdifuldSkovPaaPrivateArealerDK",
    ],
    secondaryLayers:[
      "hnvForestDK",
    ],
  },
];
